module.exports = __webpack_public_path__ + "img/middlecontrolhoz.d161d535.svg";